import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Modal, Toggle } from 'stories/components'

export const ConfirmSignDialog = (props: any) => {
  const [isReviewed, setReviewed] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const onDownloadPdf = () => {
    props.onDownloadPdf()
  }

  const onConfirmSign = async () => {
    setLoading(true)
    try {
      await props.onConfirm()
    } catch (e) {
      console.log(e)
      setLoading(false)
      return
    }

    toast('Signed successfully. You can download the signed document', { type: 'success' })

    setLoading(false)
    props.onClose()
  }

  return (
    <Modal
      isOpen
      title="Confirm and Sign"
      titleOkay="Confirm and Sign"
      disabled={!isReviewed}
      loading={isLoading}
      onClose={props.onClose}
      onOk={onConfirmSign}
    >
      <div className="mv-2 w-full max-w-[750px] overflow-hidden text-md text-gray-600">
        <p className="font-bold">Once this document is signed you will not the functionality to edit this document.</p>

        <div className="text-sm bg-gray-100 px-2 pb-4 rounded">
          <Button link onClick={onDownloadPdf}>
            <div className="flex items-start text-left underline text-gray-900 hover:text-shade-blue">
              - View Unsigned Loan Disclosures in PDF <ArrowDownTrayIcon className="ml-1 h-4 w-4 shrink-0" />
            </div>
          </Button>
          <Toggle
            id="reviewed"
            title="I have reviewed my application"
            onChange={(value) => setReviewed(value)}
            value={isReviewed}
          />
        </div>
      </div>
    </Modal>
  )
}
